import { connect } from 'react-redux';
import compose from 'recompose/compose';
import renameProp from 'recompose/renameProp';
import ShippingMethodsField from './ShippingMethodsField';
import { updateShippingMethods, getCart } from '../../../../../store/thunks/cart';

const mapDispatchToProps = (dispatch, { shipmentNumber, country }) => ({
  updateShippingMethods: async (selectedShippingRateId, errorMessage) => {
    await dispatch(updateShippingMethods({ shipmentNumber, selectedShippingRateId }, errorMessage));
    return dispatch(getCart(null, country.currency));
  }
});

const enhance = compose(
  renameProp('isShippingMethodsLoading', 'isLoading'),
  connect(null, mapDispatchToProps),
);

export default enhance(ShippingMethodsField);





// WEBPACK FOOTER //
// ./src/client/js/view/components/UserForm/Field/ShippingMethodsField/index.js